export const NEW_REQUEST = 'NEW_REQUEST';
export const USER_RATING = 'USER_RATING';
export const LIKED_REVIEW = 'LIKED_REVIEW';
export const TOP_RATED = 'TOP_RATED';
export const MOST_REQUEST = 'MOST_REQUEST';
export const MOST_LIKED = 'MOST_LIKED';
export const MOVIES = 'MOVIES';